export const TOKEN_SUCCESS = 'TOKEN_SUCCESS';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_ACTIVE = 'AUTH_ACTIVE';
export const SUBS_ACTIVE = 'SUBS_ACTIVE';
export const SESSION_CLOSE = 'SESSION_CLOSE';
